import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DigitalAsset, GungModalService, OrderServicesTicket } from 'gung-standard';
import { TyloDigitalAssetsModalComponent } from '../components/digital-assets/tylo-digital-assets-modal/tylo-digital-assets-modal.component';
import { TyloCustomerB2cPriceMarkupModalComponent } from '../components/tylo-customer-b2c-price-markup-modal/tylo-customer-b2c-price-markup-modal.component';
import { TyloReturnWarrantyCreateViewModalComponent } from '../components/tylo-return-warranty-create-view-modal/tylo-return-warranty-create-view-modal.component';
@Injectable({
  providedIn: 'root'
})
export class TyloModalService extends GungModalService{
  openDigitalAssetsModal(digitalAsset: DigitalAsset, modalOptions?: NgbModalOptions) {
    const id = TyloDigitalAssetsModalComponent.name;
    const option: NgbModalOptions = {
      backdrop: true,
      size: 'xl',
      keyboard: true,
      centered: true,
      scrollable: true,
      ...modalOptions
    };
    const ref = this.ngbModal.open(TyloDigitalAssetsModalComponent, option);
    ref.componentInstance.delegate = this;
    ref.componentInstance.selectedDigitalAsset = digitalAsset;

    this.modalRef.set(id, ref);
    return ref.result;
  }

  openTyloCustomerB2cPriceMarkupModal(): void {
    const id = TyloCustomerB2cPriceMarkupModalComponent.name;
    const option: NgbModalOptions = {
      size: 'md',
      keyboard: false,
      centered: true
    };
    const ref = this.ngbModal.open(TyloCustomerB2cPriceMarkupModalComponent, option);
    ref.componentInstance.delegate = this;

    this.modalRef.set(id, ref);
    ref.result.then(() => { location.reload(); }, () => {});
  }

    openViewCreateReturnWarrantyModal(orderServicesTicket?: OrderServicesTicket, modalOption?: NgbModalOptions) {
        const id = TyloReturnWarrantyCreateViewModalComponent.name;
        const option: NgbModalOptions = {
          size: 'lg',
          centered: true,
          backdrop: 'static',
          ariaLabelledBy: 'modal-basic-title',
          windowClass: 'modal-lg-custom',
          keyboard: true,
          ...modalOption
        };
        const ref = this.ngbModal.open(TyloReturnWarrantyCreateViewModalComponent, option);
        ref.componentInstance.delegate = this;
        ref.componentInstance.data = orderServicesTicket;
        ref.componentInstance.create = orderServicesTicket ? false : true;
    
        this.modalRef.set(id, ref);
        return ref.result;
      }
}
